"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegularIconDefinitions = void 0;
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
exports.RegularIconDefinitions = {
    CALENDAR_DAY_ICON: pro_regular_svg_icons_1.faCalendarDay,
    CALENDAR_ICON: pro_regular_svg_icons_1.faCalendar,
    CALENDAR_PLUS_ICON: pro_regular_svg_icons_1.faCalendarPlus,
    RESCHEDULE_ICON: pro_regular_svg_icons_1.faCalendarDays,
    CLOCK: pro_regular_svg_icons_1.faClock,
    BOOK: pro_regular_svg_icons_1.faBook,
    CIRCLE_QUESTION: pro_regular_svg_icons_1.faCircleQuestion,
    STAR: pro_regular_svg_icons_1.faStar,
    CALENDAR_STAR: pro_regular_svg_icons_1.faCalendarStar,
    OUTLINED_OPEN_BOOK_ICON: pro_regular_svg_icons_1.faBookOpen,
    LOCK_KEYHOLE: pro_regular_svg_icons_1.faLockKeyhole,
};
